
import axios from 'axios';

// Auto-detect production environment and use appropriate API URL
const getApiUrl = () => {
    // If explicitly set in environment, use that
    if (process.env.REACT_APP_API_URL) {
        return process.env.REACT_APP_API_URL;
    }
    
    // In development, use localhost
    if (process.env.NODE_ENV === 'development') {
        return 'http://localhost:5000/api';
    }
    
    // In production, use NEW Render backend
    return 'https://nidharsanampublictrus.onrender.com/api';
};

const API_URL = getApiUrl();

// Log the API URL for debugging (remove in production if desired)
console.log('🔗 API URL:', API_URL);

// Create axios instance with the API_URL
const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Google Drive Gallery API
export const gdriveGalleryAPI = {
    getAll: () => api.get('/gdrive-gallery/images'),
};

// Gallery API
export const galleryAPI = {
    getAll: (params) => api.get('/gallery', { params }),
    getById: (id) => api.get(`/gallery/${id}`),
    like: (id) => api.post(`/gallery/like/${id}`),
    delete: (id) => api.delete(`/gallery/${id}`),
};

// Upload API
export const uploadAPI = {
    single: (formData) => api.post('/upload/single', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
    multiple: (formData) => api.post('/upload/multiple', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
};

// Contact API
export const contactAPI = {
    submit: (data) => api.post('/contact', data),
    getAll: (params) => api.get('/contact', { params }),
    updateStatus: (id, status) => api.patch(`/contact/${id}/status`, { status }),
};

// Donation API
export const donationAPI = {
    create: (data) => api.post('/donations', data),
    getAll: (params) => api.get('/donations', { params }),
    getStats: () => api.get('/donations/stats'),
    getById: (id) => api.get(`/donations/${id}`),
};

export default api;
